<template>
  <div>
    <page-header v-bind:subtitle="$t('subtitle')"
                 v-bind:title="$t('title')" />

    <v-container v-bind:class="{ 'pa-0': !this.$vuetify.breakpoint.mdAndUp }">
      <spot-dialog ref="spotDialog"
                        v-bind:spot="selectedSpot"
                        v-model="spotDialog" />

      <spot-list-card v-bind:loading="loading"
                      v-bind:spots="spots"
                      v-on:spot-selected="showSpotDialog($event)" />
    </v-container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import SpotDialog from '@/components/SpotDialog'
  import SpotListCard from '@/components/SpotListCard'
  import PageHeader from '@/components/common/PageHeader'

  export default {
    components: {
      SpotDialog,
      SpotListCard,
      PageHeader
    },
    computed: {
      selectedSpot() {
        if (this.spotId == null) {
          return {}
        }

        return this.spot(this.spotId)
      },
      ...mapGetters([
        'spot',
        'spots'
      ])
    },
    async created() {
      // Only show placeholders when there is nothing to show yet
      this.loading = this.spots.length === 0

      try {
        await this.loadSpots()
      } finally {
        this.loading = false
      }

      if (this.$route.query?.id != null) {
        const id = parseInt(this.$route.query.id)

        if (this.spot(id) != null) {
          this.spotId = id
          this.$refs.spotDialog.open()
        }
      }
    },
    data: () => ({
      loading: false,
      spotDialog: false,
      spotId: null
    }),
    methods: {
      showSpotDialog(id) {
        this.spotId = id

        this.$refs.spotDialog.open()
      },
      ...mapActions([
        'loadSpots'
      ])
    },
    name: 'SpotsList'
  }
</script>

<i18n>
  {
    "de": {
      "subtitle": "Alle Foodspots auf einen Blick.",
      "title": "Unsere Spots"
    },
    "en": {
      "subtitle": "All food spots at a glance.",
      "title": "Our spots"
    }
  }
</i18n>
